export const NumberOutput = (str: string) => {
  const number = str.trim();
  return number.replace(/\D/g, '');
};
